export const ORGANISATION_ADMIN_DETAILS_REQUEST = "ORGANISATION_ADMIN_DETAILS_REQUEST";
export const ORGANISATION_ADMIN_DETAILS_RECEIVE = "ORGANISATION_ADMIN_DETAILS_RECEIVE";
export const ORGANISATION_ADMIN_DETAILS_FAILURE = "ORGANISATION_ADMIN_DETAILS_FAILURE";
export const RESET_ORGANISATION_ADMIN_DETAILS = "RESET_ORGANISATION_ADMIN_DETAILS";
